__turbopack_context__.v({
  "arrow": "uonoRa_arrow",
  "popoverContainer": "uonoRa_popoverContainer",
});
